import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';

import { IEventMonth } from '@adage/ace-calendar';

import { IWACEvent } from '../classes/event';
import ListRow from '../components/list-row';
import { ICalendar } from '@adage/calendar/services/calendar';

export interface ListViewRowExternalProps {
    eventMonth: ICalendar<IWACEvent>;
    monthMoment: moment.Moment;
}

interface ListViewRowInternalProps {
    innerHtml: string;
}

type ListViewRowProps = ListViewRowExternalProps & ListViewRowInternalProps;

const listMonth: React.SFC<ListViewRowProps> = (props) => {
    const beginningOfWeek = moment().startOf("week");
    const relevantDays = props.eventMonth.days.filter(day => day.events.length > 0 && moment(day.date).startOf("week").isSameOrAfter(beginningOfWeek));

    return (
        <section id={`${props.monthMoment.format("MMMM-YYYY")}-list-js`} className="list-month list-month-js">
            <h2 className="list-month-name">{props.monthMoment.format("MMMM YYYY")}</h2>
            {
                (relevantDays.length > 0) ? relevantDays.map(day => <ListRow key={day.date.toUTCString()} day={day} />) : <div className="empty-list-month" dangerouslySetInnerHTML={{
                    __html: props.innerHtml
                }} />
            }
        </section>
    );
}

export default listMonth;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/views/list-month.tsx